export const POPOVER_OPEN = 'CONFIRM_BUTTON_OPEN';
export const POPOVER_CLOSE = 'CONFIRM_BUTTON_CLOSE';

export const openPopover = id => dispatch => dispatch({ type: POPOVER_OPEN, id });
export const closePopover = id => dispatch => dispatch({ type: POPOVER_CLOSE });
